import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { apiScoping } from '@/lib/api/scoping'
import { useQuery } from '@tanstack/react-query'

export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().default(''),
  imageUrl: z.string().nullish(),
})

export type User = z.infer<typeof UserSchema>

const UsersListResponseSchema = z.object({
  users: z.array(UserSchema),
})

async function fetchUsersList(): Promise<User[]> {
  const res = await apiScoping.get('/api/v1/users/')
  return UsersListResponseSchema.parse(res.data).users
}

export const usersKeys = {
  all: ['users'] as const,
  list: () => [...usersKeys.all, 'list'] as const,
}

export function usersListQueryOptions() {
  return queryOptions({
    queryKey: usersKeys.list(),
    queryFn: fetchUsersList,
    staleTime: 5 * 60_000,
  })
}

export function useUsersList() {
  const { data, isLoading } = useQuery(usersListQueryOptions())
  return { data, isLoading }
}
